import React, { useEffect, useState } from 'react';
import GMap from './GoogleMap';

const MapView = ({
  developments,
  outsideRadiusDevelopments,
  coords,
  isLocationSearch,
  handleMarkerClick,
  loading,
}) => {
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    setMarkers([...developments, ...outsideRadiusDevelopments]);
    return () => {
      setMarkers([]);
    };
  }, [developments, outsideRadiusDevelopments]);

  return (
    <GMap
      defaultCenter={{
        lat: coords.lat ? +coords.lat : 52.0795991,
        lng: coords.lng ? +coords.lng : -1.7733696,
      }}
      handleMarkerClick={handleMarkerClick}
      distance={coords.distance}
      loading={loading}
      isLocationSearch={isLocationSearch}
      markers={markers}
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDmJX42SNd33pn4c5WnKKAIaMWCYfRq9gk"
      loadingElement={<div className="loader" />}
      containerElement={
        <div
          className="mapContainer"
          style={{ width: '100%', height: '100%' }}
        />
      }
      mapElement={<div className="map" style={{ height: '100%' }} />}
    />
  );
};

export default MapView;
